import axios from "axios";

export const downloadFileFromUrl = async (url: string, filename: string) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading file:", error);
    // Fallback to opening in new tab if download fails
    window.open(url, "_blank");
  }
};
